const factory = Model => {
  class BillingPartner extends Model {}

  BillingPartner.prototype.$resource = 'partner';

  return BillingPartner;
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.billingPartner', moduleDeps)
  .factory('BillingPartner', factory);
